import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { FC, useContext, useState } from 'react';
import Context from '../context';

import { ActionSizeContainer } from './actionsizecontainer';
import { RepeatingActionsLoops } from './repeatingactionsloops';
import { Resources } from './resources';

const expandIcon: IIconProps = { iconName: 'ChevronDownMed' };
const collapseIcon: IIconProps = { iconName: 'ChevronUpMed' };

export const AdvancedOptions: FC<{}> = () => {
    const { state } = useContext(Context);
    const [isAdvancedOptionsCollapsed, setIsAdvancedOptionsCollapsed] = useState(false);

    const onIconButtonClicked = (): void => {
        setIsAdvancedOptionsCollapsed(!isAdvancedOptionsCollapsed);
    }

    return (
        <div className="advanced-options-container">
            <div className="advanced-options-header">
                <Label id="advancedoptions" className="advanced-options-label">{Resources.ADVANCED_OPTIONS_LABEL}</Label>
                <IconButton aria-label={isAdvancedOptionsCollapsed ? "expand" : "collapse"} className="advanced-options-expand" iconProps={isAdvancedOptionsCollapsed ? expandIcon : collapseIcon} onClick={onIconButtonClicked} />
            </div>
            {!isAdvancedOptionsCollapsed
                ? <>  
                    <Label className="calc-advanced-options-info-label">{Resources.ADVANCED_OPTIONS_INFO_QUESTION}​​</Label>
                    <p className="calc-advanced-options-info">​
                        {Resources.ADVANCED_OPTIONS_INFO}
                    </p>
                
                <div className="advanced-options-children">
                        <RepeatingActionsLoops hidden={isAdvancedOptionsCollapsed} />
                        <ActionSizeContainer hidden={isAdvancedOptionsCollapsed || state.workflowActions.length === 0} />
                    </div>
                </>
                : undefined
            }
        </div>
    );
}